import axios from 'axios';
import { Message } from 'element-ui';
import store from "../vuex/index";
import storage from 'good-storage'
let req = obj => {
    return new Promise(async (resolve, reject) => {
        let method = obj.method ? obj.method : "GET";
        let res = await axios({
            url: store.state.url + obj.url,
            params: method == "GET" ? obj.data : "",
            data: method == "GET" ? "" : obj.data,
            method,
            headers: {
                token: storage.get("token") || ""
            },
        });
        if (res.status == 200 && res.data.code == 200) {
            resolve(res.data.data);
        } else {
            Message.error(res.data.msg)
            reject(res)
        }
    })
}
export default {
    req
}


// WEBPACK FOOTER //
// ./src/assets/util.js